import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import CreditAccess from "@/components/CreditAccess";
import Manifesto from "@/components/Manifesto";
import EducationHub from "@/components/EducationHub";
import Testimonials from "@/components/Testimonials";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Services />
      <CreditAccess />
      <Manifesto />
      <EducationHub />
      <Testimonials />
      <ContactSection />
      <Footer />
    </main>
  );
}
